import CoursesService from "@/services/CoursesService";
import { getListItems, getListPagination } from "@/utils/listHelpers";
import { getApiErrorMessage, notifyStoreError } from "@/utils/storeHelpers";

export default {
    namespaced: true,
    state: {
        coursesData: [],
        course: [],
        newCourse: [],
        status: null,
    },
    getters: {
        getCoursesData: (state) => getListItems(state.coursesData),
        getCoursesPagination: (state) => getListPagination(state.coursesData),
        getCourseData: (state) => state.course,
        getNewCourseData: (state) => state.newCourse,
        getStatus: (state) => state.status,
    },
    mutations: {
        setCoursesData(state, data) {
            state.coursesData = data;
        },
        setCourseData(state, data) {
            state.course = data;
        },
        setNewCourseData(state, data) {
            state.newCourse = data;
        },
        setStatus(state, status) {
            state.status = status;
        },
    },
    actions: {
        async getCourses({ commit, dispatch }, payload) {
            try {
                const response = await CoursesService.getCourses(payload.data, payload.userToken);
                commit('setCoursesData', response);
            } catch (error) {
                console.error('Erro ao buscar cursos', error);
                commit('setStatus', getApiErrorMessage(error, 'Erro ao buscar cursos'));
            } finally {
                if (payload.skeletonKey) {
                    dispatch('skeleton/setLoadingState', { key: payload.skeletonKey, value: false }, { root: true })
                }
            }
        },
        async createCourse({ commit, dispatch, state }, payload) {
            try {
                const response = await CoursesService.createCourse(payload.course, payload.userToken);

                let updatedCoursesData = null;
                const newCourse = response.data || response;

                if (Array.isArray(state.coursesData)) {
                    updatedCoursesData = [...state.coursesData, newCourse];
                } else if (state.coursesData && Array.isArray(state.coursesData.data)) {
                    updatedCoursesData = {
                        ...state.coursesData,
                        data: [...state.coursesData.data, newCourse]
                    };
                }

                if (updatedCoursesData) {
                    commit('setCoursesData', updatedCoursesData);
                }

                commit('setStatus', 'Curso adicionado com sucesso');
                return response;
            } catch (error) {
                notifyStoreError(dispatch, 'Erro ao adicionar curso', error);
                throw error;
            }
        },
        async getCourse({ commit }, payload) {
            try {
                const response = await CoursesService.getCourseById(payload.data, payload.userToken);
                commit('setCourseData', response.data);
            } catch (error) {
                console.error('Erro ao buscar curso', error);
                commit('setStatus', getApiErrorMessage(error, 'Erro ao buscar curso'));
            }
        },
        async updateCourse({ commit, state, dispatch }, payload) {
            try {
                const response = await CoursesService.updateCourse(payload.data, payload.userToken);
                const updatedCourse = response.data || response;

                dispatch('toastfy/activeSuccesNotification', { text: "Curso atualizado com sucesso" }, { root: true });

                if (Array.isArray(state.coursesData)) {
                    const newList = state.coursesData.map(c => c.id === updatedCourse.id ? updatedCourse : c);
                    commit('setCoursesData', newList);
                } else if (state.coursesData?.data && Array.isArray(state.coursesData.data)) {
                    const newList = state.coursesData.data.map(c => c.id === updatedCourse.id ? updatedCourse : c);
                    commit('setCoursesData', {
                        ...state.coursesData,
                        data: newList
                    });
                }

                return response;
            } catch (error) {
                notifyStoreError(dispatch, 'Erro ao atualizar curso', error);
                throw error;
            }
        },
        async deleteCourse({ commit, state, dispatch }, payload) {
            try {
                await CoursesService.deleteCourse(payload.data, payload.userToken);

                dispatch('toastfy/activeSuccesNotification', { text: "Curso excluído com sucesso" }, { root: true });

                if (Array.isArray(state.coursesData)) {
                    const newList = state.coursesData.filter(c => c.id !== payload.data);
                    commit('setCoursesData', newList);
                } else if (state.coursesData?.data && Array.isArray(state.coursesData.data)) {
                    const newList = state.coursesData.data.filter(c => c.id !== payload.data);
                    commit('setCoursesData', {
                        ...state.coursesData,
                        data: newList
                    });
                }
            } catch (error) {
                notifyStoreError(dispatch, 'Erro ao deletar curso', error);
                throw error;
            }
        },
    }
}
